import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { AnalyticsService } from '@se-po/shared-data-access-services'
import { SetupBarService } from '@se-po/shared-ui-setup-bar'

@Component({
  selector: 'se-po-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss'],
  standalone: false,
})
export class ReviewComponent implements OnInit {
  public storeLoaded = false
  public child: any
  public parent: any
  public guardianInvites: any[] = []
  private readonly app = 'SingleSignOn'
  private readonly page = 'HouseholdSetup'
  private readonly label = 'ReviewInfo'

  constructor(
    private analyticsService: AnalyticsService,
    public store: StoreService,
    public setupBarService: SetupBarService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.parent = this.store.accountInfo
    this.child = this.store.childInfo
    this.guardianInvites = this.store.draftGuardianInvites?.value || []
    this.setupBarService.setAttributes({
      title: 'Create Account',
      percentComplete: 70
    })
    this.storeLoaded = true
    this.analyticsService.pageView(this.app, this.page, this.label)
  }

  public onCancelInvite(email: string): void {
    this.analyticsService.seEvent(`${this.page}.${this.label}.CancelInvite`)
    this.guardianInvites = this.guardianInvites.filter(invite => invite.email !== email)
    this.store.draftGuardianInvites.next(this.guardianInvites)
  }

  public onContinue(): void {
    void this.router.navigate([this.store.basePath, 'create-password'])
  }

  public onAddAnother(): void {
    this.analyticsService.seEvent(`${this.page}.${this.label}.InviteAnother`)
    void this.router.navigate([this.store.basePath, 'guardian-invite'])
  }
}
